import React from 'react';
class AlphabetFilter extends React.Component{
    constructor(props){
        super(props);

        this.state = {
            chart_array: []
        }
    }

    componentDidMount(){
        this.genCharArray('A','Z');
    }

    genCharArray = (charA, charZ) =>{
        var aphabet = [], i = charA.charCodeAt(0), j = charZ.charCodeAt(0);
        for (; i <= j; ++i) {
            aphabet.push(String.fromCharCode(i));
        }
        this.setState({
            chart_array: aphabet
        });
    }

    handleClick = (chart) =>{
        this.props.onFilter(chart);
    }

    render(){

        return (
            <div className="d-flex flex-wrap justify-content-center mb-3">
                {
                    this.state.chart_array.map((aChart,index) =>(
                    <button onClick={() =>this.handleClick(aChart.toLowerCase())} className="btn btn-filter btn-sm m-1" key={index}>
                        {aChart}
                    </button>

                    ))
                }
            </div>
        )
    }
}

export default AlphabetFilter;